import { useQuery } from '@tanstack/react-query';
import PathwayService from '@/services/PathwayService';
import type { CarePathwayPreset } from '@/services/PathwayService';
import { PATHWAY_KEYS } from './keys';

export function useCarePathwayPresets() {
  return useQuery({
    queryKey: PATHWAY_KEYS.presets(),
    queryFn: () => PathwayService.listCarePathwayPresets(),
  });
}

export type { CarePathwayPreset };
